
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as Indextvj_iYP8r1z_RMAaU5psY9MPsbvZp8HDitm14_453bWkUMeta } from "/builds/devhacker/burninghut/bh-frontend/pages/Index.vue?macro=true";
import { default as ArchiveTagAXs9Aw47sheC2i94mspnmrdHOTvOmQXRwm8SFW70PzAMeta } from "/builds/devhacker/burninghut/bh-frontend/pages/ArchiveTag.vue?macro=true";
import { default as ArchiveSearchcbLQ6duqodgUhP4F8rJ5zqnNAwhxqdfls0eqTqah_wEMeta } from "/builds/devhacker/burninghut/bh-frontend/pages/ArchiveSearch.vue?macro=true";
import { default as ArchiveTopdXARhSOZhoNOXiPf30gv696FyQhekr9Ha7FbWsyw7h8Meta } from "/builds/devhacker/burninghut/bh-frontend/pages/ArchiveTop.vue?macro=true";
import { default as ArchiveAuthorwmdVroNj8eFkklIkO_45qGoq_u4HK4M9J5sD6hIrQTFwwMeta } from "/builds/devhacker/burninghut/bh-frontend/pages/ArchiveAuthor.vue?macro=true";
import { default as ArchiveCategoryuDIzMbfn1cjMFqADiH5fZZxnEJZ_458QPH530xvzxrlfQMeta } from "/builds/devhacker/burninghut/bh-frontend/pages/ArchiveCategory.vue?macro=true";
import { default as ArchiveAlliSR8HZ5j9YTOxBgXUn7LG6VKcuf1R9rx6MYLpkbJqjYMeta } from "/builds/devhacker/burninghut/bh-frontend/pages/ArchiveAll.vue?macro=true";
import { default as Article5BfIaIts7klW12Puk6_45TbUpW4JArhQ5f7egWEXhvO1MMeta } from "/builds/devhacker/burninghut/bh-frontend/pages/Article.vue?macro=true";
import { default as article_46ampnlmDHOOXvPqU5D_4511YCkU5B8jbsCJMg35LnZo7UsLoAMeta } from "../pages/article.amp.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/builds/devhacker/burninghut/bh-frontend/pages/Index.vue")
  },
  {
    name: "archive-tag-page",
    path: "/tag",
    component: () => import("/builds/devhacker/burninghut/bh-frontend/pages/ArchiveTag.vue"),
    children: [
  {
    name: "archive-tag-name",
    path: ":tagName",
    component: () => import("/builds/devhacker/burninghut/bh-frontend/pages/ArchiveTag.vue")
  },
  {
    name: "archive-tag-number",
    path: ":tagName/page/:pageNumber(\\d+)",
    component: () => import("/builds/devhacker/burninghut/bh-frontend/pages/ArchiveTag.vue")
  }
]
  },
  {
    name: "search",
    path: "/search",
    meta: {"type":"search"},
    component: () => import("/builds/devhacker/burninghut/bh-frontend/pages/ArchiveSearch.vue")
  },
  {
    path: "/search/*",
    redirect: "/search"
  },
  {
    name: "archive-top-page",
    path: "/top",
    component: () => import("/builds/devhacker/burninghut/bh-frontend/pages/ArchiveTop.vue"),
    children: [
  {
    name: "archive-top-period",
    path: ":topPeriod",
    component: () => import("/builds/devhacker/burninghut/bh-frontend/pages/ArchiveTop.vue")
  },
  {
    name: "archive-top-number",
    path: ":topPeriod/page/:pageNumber(\\d+)",
    component: () => import("/builds/devhacker/burninghut/bh-frontend/pages/ArchiveTop.vue")
  }
]
  },
  {
    name: "archive-author-page",
    path: "/author",
    component: () => import("/builds/devhacker/burninghut/bh-frontend/pages/ArchiveAuthor.vue"),
    children: [
  {
    name: "archive-author-slug",
    path: ":authorSlug",
    component: () => import("/builds/devhacker/burninghut/bh-frontend/pages/ArchiveAuthor.vue")
  },
  {
    name: "archive-author-number",
    path: ":authorSlug/page/:pageNumber(\\d+)",
    component: () => import("/builds/devhacker/burninghut/bh-frontend/pages/ArchiveAuthor.vue")
  }
]
  },
  {
    name: "archive-category-page",
    path: "/category",
    component: () => import("/builds/devhacker/burninghut/bh-frontend/pages/ArchiveCategory.vue"),
    children: [
  {
    name: "archive-category-slug",
    path: ":categorySlug",
    component: () => import("/builds/devhacker/burninghut/bh-frontend/pages/ArchiveCategory.vue")
  },
  {
    name: "archive-category-number",
    path: ":categorySlug/page/:pageNumber(\\d+)",
    component: () => import("/builds/devhacker/burninghut/bh-frontend/pages/ArchiveCategory.vue")
  }
]
  },
  {
    name: "archive-all",
    path: "/page",
    component: () => import("/builds/devhacker/burninghut/bh-frontend/pages/ArchiveAll.vue"),
    children: [
  {
    name: "archive-all-with-page",
    path: ":pageNumber",
    component: () => import("/builds/devhacker/burninghut/bh-frontend/pages/ArchiveAll.vue")
  }
]
  },
  {
    name: "preview",
    path: "/preview/:postId",
    meta: { ...(Article5BfIaIts7klW12Puk6_45TbUpW4JArhQ5f7egWEXhvO1MMeta || {}), ...{"middleware":["article-data","preview-data"]} },
    component: () => import("/builds/devhacker/burninghut/bh-frontend/pages/Article.vue")
  },
  {
    name: "preview-public",
    path: "/preview/:postId/public",
    meta: { ...(Article5BfIaIts7klW12Puk6_45TbUpW4JArhQ5f7egWEXhvO1MMeta || {}), ...{"middleware":["article-data","preview-data"]} },
    component: () => import("/builds/devhacker/burninghut/bh-frontend/pages/Article.vue")
  },
  {
    name: "article-amp",
    path: "/:slug/amp",
    component: () => import("../pages/article.amp.vue")
  },
  {
    name: "article",
    path: "/:article",
    meta: { ...(Article5BfIaIts7klW12Puk6_45TbUpW4JArhQ5f7egWEXhvO1MMeta || {}), ...{"middleware":["article-data","preview-data"]} },
    component: () => import("/builds/devhacker/burninghut/bh-frontend/pages/Article.vue")
  }
]